export const CARD_STATUS_ORDERED = 0;
export const CARD_STATUS_ACTIVE = 1;
export const CARD_STATUS_INACTIVE = 5;
